module.exports = __webpack_public_path__ + "img/sunset.10779319.png";